export default "__VITE_ASSET__8edce1c5__"